<template>
  <div>
    <section class="w-full pt-2 pb-6 box-border relative" v-loading="psLoading">
      <div class="pl-6 pr-4 pt-2">
        <el-steps
          direction="vertical"
          space="auto"
          finish-status="process"
          class="sett_procs_steps"
          :active="0"
        >
          <el-step>
            <template #title>
              <p
                class="w-full flex items-center justify-between select-none cursor-pointer"
                @click="step.process = !step.process"
              >
                <span>费用审批</span>
                <span class="flex items-center">
                  <span class="mr-2 text-small text-theme select-none cursor-pointer" @click.stop="toHistoryApprovalHandle"
                    >审批记录</span
                  >
                  <el-icon class="el-icon-arrow-down text-medium-x text-black tran_icon" :class="{ expand: step.process }" />
                </span>
              </p>
            </template>
            <el-collapse class="sett_procs_coll" slot="description" accordion v-model="collVal.process">
              <el-collapse-item name="process" >
                <template v-if="approvalList.length > 0">
                  <section class="max-aplist" ref="apListContainer">
                    <div
                      class="box_card p-3 mb-1 box-border rounded-small bg-card-bg-gray relative"
                      v-for="(item, index) of approvalList"
                      :key="item.id"
                      :class="getBoxClass(item, index)"
                      ref="apList"
                    >
                      <div v-if="index > 0 && getTaskStatusText(item)" class="card_status">
                        {{ getTaskStatusText(item) }}
                      </div>
                      <header class="w-full flex">
                        <div class="w-8 h-8 bg-card-bg-gray rounded-full overflow-hidden">
                          <el-tooltip placement="bottom">
                            <img class="w-full h-full" :src="item.assigneePhoto" v-if="item.assigneePhoto" />
                            <div class="w-full h-full bg-theme text-small text-white flex justify-center items-center" v-else>
                              {{ thumbName(item.name) }}
                            </div>
                            <template #content>
                              <div class="flex py-1 px-1">
                                <div class="bg-theme-gray img-box w-10 h-10 mr-3 rounded-full" v-if="item.assigneePhoto">
                                  <img class="w-full h-full rounded-full" :src="item.assigneePhoto" />
                                </div>
                                <div
                                  class="bg-theme text-small img-box w-10 h-10 mr-3 rounded-full flex justify-center items-center"
                                  v-else
                                >
                                  <span class="text-white">{{ thumbName(item.name) }}</span>
                                </div>
                                <div>
                                  <span class="leading-22 opacity-85 text-medium-x font-medium">{{ item.name }}</span>
                                  <span class="text-small opacity-65 ml-1">{{ item.assigneeDept || '' }}</span>
                                  <p class="text-small opacity-65 mt-1 font-normal">{{ item.assigneePhone }}</p>
                                </div>
                              </div>
                            </template>
                          </el-tooltip>
                        </div>
                        <div class="ml-3 mt-1 flex-1 overflow-hidden">
                          <div class="text-medium text-theme-black-850 font-semibold leading-22">
                            <el-tooltip :content="item.name" placement="top-start">
                              <span class="break-all">{{ getAssigneeName(item) }}</span>
                            </el-tooltip>
                            <span
                              class="ml-1 px-2 box-border text-theme-black-650 text-small leading-18 inline-block rounded-small border border-solid border-ccc"
                            >
                              {{ item.ideType }}
                            </span>
                          </div>
                        </div>
                      </header>
                      <div class="w-full flex">
                        <div class="w-8" />
                        <div class="ml-3 flex-1">
                          <template v-if="item.complete === completeType.COMPLETE">
                            <p class="w-full text-small text-theme-black-850 leading-tight break-all" v-if="item.comment">
                              说明：{{ item.comment }}
                            </p>
                            <p class="w-full text-small text-theme-black-450 leading-22" v-if="item.createTime">{{ item.createTime }}</p>
                          </template>
                          <div class="w-full pr-2 box-border" v-else-if="isToHandler(item,index)">
                            <!-- <el-button
                              v-if="approvalList.length - 1 === index"
                              type="primary"
                              size="mini"
                              class="mt-1 w-full"
                              :loading="payLoading"
                              @click="toPayHandle(item.id)"
                            >
                              去支付
                            </el-button> -->
                            <el-button type="primary" size="mini" class="mt-1 w-full" @click="toApprovalHandle(item.id)"
                              >去审批</el-button
                            >
                          </div>
                          <div class="w-full pr-2 box-border" v-else-if="isDiffToHandler(item,index)">
                            <!-- <el-button
                              type="primary"
                              size="mini"
                              class="mt-1 w-full"
                              disabled
                              v-if="approvalList.length - 1 === index"
                              >支付中</el-button
                            > -->
                            <el-button type="primary" size="mini" class="mt-1 w-full" disabled >审批中</el-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                  <!-- <p class="w-full text-yellow-theme flex" v-if="isResetApproval">
                    <i class="el-icon-warning-outline mt-1 mr-1 text-medium"></i>
                    <span class="flex-1 text-small leading-18">
                      审批驳回，您可&nbsp;
                      <span class="text-theme cursor-pointer select-none" @click="resetInitApproval"> 重新提交费用审批 </span>
                    </span>
                  </p> -->
                </template>
                <!-- <div class="w-full" v-else>
                  <el-button type="primary" size="mini" @click="submitInitApproval" v-if="!isInitErr">提交费用审批</el-button>
                </div> -->
              </el-collapse-item>
            </el-collapse>
          </el-step>
        </el-steps>
      </div>
      <div class="absolute bottom-0 w-full h-px px-6 box-border">
      <div class="w-full f-full border-b border-solid border-border-gray" />
    </div>
    </section>
    <Help/>
    <AuditRecord :visibility.sync="visibility" :id="$route.params.id"/>
    <!-- <choose-approver ref="chooseApprover" :sid="$route.params.id" @finished-approval="finishedApproval" /> -->
  </div>
</template>

<script>
import Help from '@/views/home/cost-settlement/components/Help'
import AuditRecord from '@/views/home/cost-settlement/components/AuditRecord.vue'
import { statisticsDetail, getCompanyPlatformBalance } from '@/api/cost-settlement/common'
import { getApprovalDetailProcess, getApprovalDetail, toApproval } from '@/api/cost-settlement/myRelate'
import { getInvestigatorStatementList } from '@/api/cost-settlement/settlement-initiate/submitStatement'
import { completeType, constantAP } from '@/views/home/cost-settlement/config/cost-sett'
import ApprovalDialog from '@/views/home/cost-settlement/components/ApprovalDialog'
import ChooseApprover from '@/views/home/cost-settlement/settlement-initiate/settle-process/components/ChooseApprover'
import { getWjawardSummary , getperson, getpersonMsg, getMsgAuditSummary } from '@/api/cost-settlement/approve'
import { createPopup } from '@/assets/js/factory'
import GlobalConfig from '@/global/config'
import { soTypeCode } from '../../config/cost-sett'

export default {
  name: 'ApproveDetailSide',
  components: { Help, AuditRecord },
  props: {
    id: {
      type: [String, Number],
      default: ''
    },
  },
  data() {
    return {
      psLoading: false,
      step: {
        process: false
      },
      visibility: false,
      approvalList: [],
      completeType,
      constantAP,
      isInitErr: false,
    }
  },
  computed: {
    collVal() {
      const coll = {}
      for (const key in this.step) {
        coll[key] = this.step[key] ? key : ''
      }
      return coll
    },
    rejectIndex() {
      return this.approvalList.findIndex(f => f.auditStatus === 3)
    },
    isReject() {
      return this.rejectIndex > -1
    },
    isCurrentCreateUser() {
      const createUserInfo = this.approvalList[0]
      if (!createUserInfo) return false
      return createUserInfo.createUserId === this.$store.getters?.userInfo?.userId
    },
    isResetApproval() {
      return this.isReject && this.isCurrentCreateUser
    },
    userDygcStaffId() {
      return GlobalConfig.getDygcStaffId()
    },
    soType() {
      const type = this.$route.query.approveType ?? ''
      return type === '' ? '' : +type
    },
    isRedPocketAudit() {
      return this.soType && this.soType === soTypeCode.PACKET
    },
    isMessageAudit() {
      return this.soType && this.soType === soTypeCode.MESSAGE
    },
    personApi() {
      if(this.isRedPocketAudit) {
        return getperson
      }else {
        return getpersonMsg
      }
    },
    approvalDetailApi() {
      if(this.isRedPocketAudit) {
        return getWjawardSummary
      }else if(this.isMessageAudit) {
        return getMsgAuditSummary
      }
    }
  },
  mounted() {
    this.getPersonnelList()
  },
  methods: {
    getPersonnelList() {
      if (this.id) {
        this.isInitErr = false
        this.personApi(this.id).then(res => {
          const list = res?.data?.data || []
          this.step.process=true
          this.approvalList = list.map((m) => {
            let ideType = ''
            switch (m.type) {
              case 1:
                ideType = '发起人'
                break
              case 2:
                ideType = '审批人'
                break
            }
            return {
              ...m,
              ideType
            }
          })
          this.psLoading = false
        }).catch(() => {
          this.$message.error('获取审批流程失败')
          this.isInitErr = true
          this.psLoading = false
        })
     } else {
        this.$message.error('无statementId')
    }
    this.$emit('approval-success')
    },

    getBoxClass(item, index) {
      if (item.complete === completeType.COMPLETE) {
        if (index === 0) return 'card_blue'
        if (2 === item.auditStatus) return 'card_green'
        if (3 === item.auditStatus) return 'card_red'
      }
      return 'card_gray'
    },
    getTaskStatusText(item) {
      const { auditStatus } = item
      let status = ''
        switch (auditStatus) {
          // case 1:
          //   status = '待审批'
          //   break
          case 2:
            status = '已通过'
            break
            case 3:
            status = '已驳回'
            break
        }
      return status
    },
    getAssigneeName(item) {
      const name = item.name || ''
      return name.length > 15 ? `${name}…` : name
    },
    thumbName(name) {
      return (name || '').slice(-2)
    },
    isToHandler(item,index) {
      if (item.type === 1) return false
      const baseCondition =
        item.complete === completeType.UN_COMPLETE && !this.isReject && this.userDygcStaffId === item.userId
      if (index === 1) return baseCondition
      return baseCondition && this.approvalList[index-1].auditStatus === 2
    },
    isDiffToHandler(item,index) {
      if (item.type === 1) return false
      const baseCondition =
        item.complete === completeType.UN_COMPLETE && !this.isReject && this.userDygcStaffId !== item.userId
      if (index === 1) return baseCondition
      return baseCondition && this.approvalList[index-1].auditStatus === 2
    },
    // toPayHandle(taskId) {
    //   if (this.settlementInfo.status === platformStatusCode.OFF) {
    //     this.$message.warning('支付方式未开通，请先开通后重试')
    //   } else {
    //     if (this.settlementType === settlementTypeCode.OPENSIGN) {
    //       this.payLoading = true
    //       Promise.all([getApprovalDetail(taskId), getCompanyPlatformBalance(this.id)])
    //         .then(([adRes, cbRes]) => {
    //           const ad = adRes?.data?.data || {}
    //           const settlementAccountBalance = cbRes?.data?.data ?? 0
    //           if (ad.operationalYuanAmount <= settlementAccountBalance) {
    //             // 结算小于账户余额
    //             createPopup(
    //               ApprovalDialog,
    //               {
    //                 pay: true,
    //                 approvalInfo: ad,
    //                 id: taskId,
    //                 statementId: this.id,
    //                 soType: +this.soType,
    //                 companyAccount: settlementAccountBalance,
    //                 sponsor: this.approvalList[0] || {},
    //                 planCategory: this.settlementInfo.planCategory,
    //                 payPlatformCategory: this.settlementInfo.payPlatformCategory,
    //                 onApprovalSuccess: this.getProcessDetail.bind(this)
    //               },
    //               {
    //                 store: this.$store,
    //                 router: this.$router
    //               }
    //             )
    //           } else {
    //             // 结算大于账户余额
    //             this.showCP = true
    //             this.cpId = taskId
    //           }
    //         })
    //         .catch(() => {
    //           this.$message.error('获取支付信息失败')
    //         })
    //         .finally(() => {
    //           this.payLoading = false
    //         })
    //     } else {
    //       this.$message.warning('支付方式未签约，请先签约后重试')
    //     }
    //   }
    // },
    toApprovalHandle(taskId = '') {
      this.psLoading = true
      this.approvalDetailApi(this.$route.params.id).then((res) => {
        const list = res.data.data || [];
        const sponsor = list;
        const { planCategory, payPlatformCategory } = this.$store.getters.settlementInfo || {};
        const queryList = typeof this.queryList === 'function' ? this.queryList : () => {};
        const id = this.isRedPocketAudit ? this.$route.query.awardId : this.$route.params.id;
        createPopup(ApprovalDialog, {
          sponsor,
          id,
          statementId: this.id,
          soType: +this.$route.query.approveType,
          planCategory,
          payPlatformCategory,
          onApprovalSuccess: ()=> { this.getPersonnelList.bind(this)(); this.$emit('finished') },
          pageType: +this.$route.query.approveType,
          approvalInfo: list, 
        },{
          store: this.$store,
          router: this.$router
        });

      }).catch(() => {
        this.$message.error('获取审批流程数据失败');
      }).finally(() => {
        this.psLoading = false
      });
    },
    // submitInitApproval() {
    //   if (this.$refs.chooseApprover) {
    //     this.$refs.chooseApprover.open()
    //   }
    // },
    // resetInitApproval() {
    //   if (this.$refs.chooseApprover) {
    //     // this.$refs.chooseApprover.isCheck = false;
    //     this.$refs.chooseApprover.open()
    //   }
    // },
    // finishedApproval() {
    //   if (this.process.settleStage >= 4) {
    //     this.$refs.chooseApprover.drawer = false
    //     this.getProcessApprovalDetail()
    //   }
    //   this.$emit('finished-approval')
    // },
    toHistoryApprovalHandle() {
      this.visibility = true
    }
  }
}
</script>

<style lang="scss" scoped>
.sett_procs_steps {
  ::v-deep .el-step.is-vertical {
    .el-step__head {
      @apply w-4;
      &.is-process {
        .el-step__line {
          @apply bg-theme;
        }
        .el-step__icon {
          @apply text-theme border-theme;
        }
      }
    }
    .el-step__line {
      width: 1px;
      top: 16px;
      left: 8px;
    }
    .el-step__icon {
      @apply w-4 h-4 bg-white text-ccc border border-solid border-ccc flex items-center justify-center;
      &.is-text {
        @apply border;
      }
      .el-step__icon-inner {
        @apply text-small font-normal;
      }
    }
    .el-step__title {
      @apply pb-0 pl-2 h-4 font-medium text-medium text-theme-black-850 flex items-center;
      line-height: 1;
      &.is-wait {
        @apply text-theme-black-450;
      }
    }
    .el-step__main {
      @apply pl-0;
    }

    .el-collapse-item__wrap {
      @apply border-b-0 overflow-visible;
      max-height: 1000px;
    }
    .el-collapse-item__content {
      @apply pb-0;
    }
    .el-step__description {
      @apply pr-0;
    }
  }
  ::v-deep .sett_procs_coll {
    @apply border-0 py-3;
    .el-collapse-item__header {
      @apply hidden;
    }
  }
  ::v-deep .last_sett_procs_coll {
    @apply border-0 py-0;
    .el-collapse-item__header {
      @apply hidden;
    }
  }
  .tran_icon {
    transition: transform 0.3s;
    &.expand {
      transform: rotate(-180deg);
    }
  }
  .box_card {
    width: 100%;
  }
  .card_status {
    @apply h-5 px-2 box-border flex items-center justify-center text-small text-white leading-none whitespace-nowrap absolute top-0 right-0;
    min-width: 52px;
    border-bottom-left-radius: 2px;
  }
  .card_blue {
    .card_status {
      @apply bg-theme;
    }
    &::before {
      content: '';
      @apply w-1 h-full bg-theme absolute top-0 left-0;
    }
  }
  .card_red {
    .card_status {
      @apply bg-danger;
    }
    &::before {
      content: '';
      @apply w-1 h-full bg-danger absolute top-0 left-0;
    }
  }
  .card_green {
    .card_status {
      @apply bg-green-theme;
    }
    &::before {
      content: '';
      @apply w-1 h-full bg-green-theme absolute top-0 left-0;
    }
  }
  .card_gray {
    .card_status {
      @apply bg-bg-common-color;
    }
    &::before {
      content: '';
      @apply w-1 h-full bg-bg-common-color absolute top-0 left-0;
    }
  }
  .max-aplist {
    max-height: 340px;
    margin-left: -8px;
    overflow-y: auto;
    // &::-webkit-scrollbar {
    //   display: none;
    // }
    // &:hover {
    //   &::-webkit-scrollbar {
    //     display: block;
    //   }
    // }
  }
}
</style>